import React from 'react';

const MembersShowcase = () => {
  const members = [
    { name: 'Dr. Adebayo Ogunlesi', company: 'Global Infrastructure Partners', country: 'Nigeria' },
    { name: 'Ms. Amina Mohammed', company: 'UN Development Programme', country: 'Nigeria' },
    { name: 'Mr. Strive Masiyiwa', company: 'Econet Group', country: 'Zimbabwe' },
    { name: 'Dr. Mo Ibrahim', company: 'Mo Ibrahim Foundation', country: 'Sudan' },
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Members Showcase</h1>
        <p>Distinguished members of our forum</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="members-grid">
            {members.map((member, index) => (
              <div className="member-card" key={index}>
                <h3>{member.name}</h3>
                <p><strong>{member.company}</strong></p>
                <p>{member.country}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default MembersShowcase;